import * as Types from '../../constants/actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case Types.GET_LIST_RECENT_ACCESS: {
            return {
                ...state,
                recentAccessList: action.recentAccessList,
            }
        }
        case Types.CREATE_RECENT_ACCESS: {
            return state;
        }
        case Types.REQUEST_RECENT_ACCESS_ERROR: {
            return {
                ...state,
                recentAccessError: action.error,
            }
        }

        default:
            return state;
    }
};
